export const version = "wallet/5.6.2";
